// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authenticatedRouteRouteImport } from './routes/(authenticated)/route'
import { Route as authPagesRouteRouteImport } from './routes/(auth-pages)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authenticatedOnboardingRouteRouteImport } from './routes/(authenticated)/onboarding/route'
import { Route as authenticatedDashboardRouteRouteImport } from './routes/(authenticated)/dashboard/route'
import { Route as authPagesSignupRouteImport } from './routes/(auth-pages)/signup'
import { Route as authPagesResetPasswordRouteImport } from './routes/(auth-pages)/reset-password'
import { Route as authPagesLoginRouteImport } from './routes/(auth-pages)/login'
import { Route as authPagesForgotPasswordRouteImport } from './routes/(auth-pages)/forgot-password'
import { Route as authenticatedOnboardingIndexRouteImport } from './routes/(authenticated)/onboarding/index'
import { Route as authenticatedOnboardingTestConnectionRouteImport } from './routes/(authenticated)/onboarding/test-connection'
import { Route as authenticatedOnboardingTemplatesRouteImport } from './routes/(authenticated)/onboarding/templates'
import { Route as authenticatedOnboardingProviderRouteImport } from './routes/(authenticated)/onboarding/provider'
import { Route as authenticatedOnboardingCompleteRouteImport } from './routes/(authenticated)/onboarding/complete'
import { Route as authenticatedDashboardIndexRouteImport } from './routes/(authenticated)/dashboard/index'
import { Route as authenticatedDashboardSettingsRouteRouteImport } from './routes/(authenticated)/dashboard/settings/route'
import { Route as authenticatedDashboardAdminRouteRouteImport } from './routes/(authenticated)/dashboard/admin/route'
import { Route as authenticatedDashboardChatNewRouteImport } from './routes/(authenticated)/dashboard/chat/new'
import { Route as authenticatedDashboardChatChatIdRouteImport } from './routes/(authenticated)/dashboard/chat/$chatId'
import { Route as authenticatedDashboardSettingsIndexRouteImport } from './routes/(authenticated)/dashboard/settings/index'
import { Route as authenticatedDashboardAdminIndexRouteImport } from './routes/(authenticated)/dashboard/admin/index'
import { Route as authenticatedDashboardSettingsTemplatesIndexRouteImport } from './routes/(authenticated)/dashboard/settings/templates/index'
import { Route as authenticatedDashboardSettingsSyncIndexRouteImport } from './routes/(authenticated)/dashboard/settings/sync/index'
import { Route as authenticatedDashboardSettingsProvidersIndexRouteImport } from './routes/(authenticated)/dashboard/settings/providers/index'
import { Route as authenticatedDashboardSettingsTemplatesNewRouteImport } from './routes/(authenticated)/dashboard/settings/templates/new'
import { Route as authenticatedDashboardSettingsProvidersAddRouteImport } from './routes/(authenticated)/dashboard/settings/providers/add'
import { Route as authenticatedDashboardAdminModelsIndexRouteImport } from './routes/(authenticated)/dashboard/admin/models/index'
import { Route as authenticatedDashboardSettingsTemplatesTemplateIdIndexRouteImport } from './routes/(authenticated)/dashboard/settings/templates/$templateId/index'
import { Route as authenticatedDashboardSettingsTemplatesTemplateIdEditRouteImport } from './routes/(authenticated)/dashboard/settings/templates/$templateId/edit'

const authenticatedRouteRoute = authenticatedRouteRouteImport.update({
            id: '/(authenticated)',getParentRoute: () => rootRouteImport
          })
const authPagesRouteRoute = authPagesRouteRouteImport.update({
            id: '/(auth-pages)',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const authenticatedOnboardingRouteRoute = authenticatedOnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => authenticatedRouteRoute
          })
const authenticatedDashboardRouteRoute = authenticatedDashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => authenticatedRouteRoute
          })
const authPagesSignupRoute = authPagesSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => authPagesRouteRoute
          })
const authPagesResetPasswordRoute = authPagesResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => authPagesRouteRoute
          })
const authPagesLoginRoute = authPagesLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => authPagesRouteRoute
          })
const authPagesForgotPasswordRoute = authPagesForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => authPagesRouteRoute
          })
const authenticatedOnboardingIndexRoute = authenticatedOnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => authenticatedOnboardingRouteRoute
          })
const authenticatedOnboardingTestConnectionRoute = authenticatedOnboardingTestConnectionRouteImport.update({
            id: '/test-connection',path: '/test-connection',getParentRoute: () => authenticatedOnboardingRouteRoute
          })
const authenticatedOnboardingTemplatesRoute = authenticatedOnboardingTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => authenticatedOnboardingRouteRoute
          })
const authenticatedOnboardingProviderRoute = authenticatedOnboardingProviderRouteImport.update({
            id: '/provider',path: '/provider',getParentRoute: () => authenticatedOnboardingRouteRoute
          })
const authenticatedOnboardingCompleteRoute = authenticatedOnboardingCompleteRouteImport.update({
            id: '/complete',path: '/complete',getParentRoute: () => authenticatedOnboardingRouteRoute
          })
const authenticatedDashboardIndexRoute = authenticatedDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => authenticatedDashboardRouteRoute
          })
const authenticatedDashboardSettingsRouteRoute = authenticatedDashboardSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => authenticatedDashboardRouteRoute
          })
const authenticatedDashboardAdminRouteRoute = authenticatedDashboardAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => authenticatedDashboardRouteRoute
          })
const authenticatedDashboardChatNewRoute = authenticatedDashboardChatNewRouteImport.update({
            id: '/chat/new',path: '/chat/new',getParentRoute: () => authenticatedDashboardRouteRoute
          })
const authenticatedDashboardChatChatIdRoute = authenticatedDashboardChatChatIdRouteImport.update({
            id: '/chat/$chatId',path: '/chat/$chatId',getParentRoute: () => authenticatedDashboardRouteRoute
          })
const authenticatedDashboardSettingsIndexRoute = authenticatedDashboardSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardAdminIndexRoute = authenticatedDashboardAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => authenticatedDashboardAdminRouteRoute
          })
const authenticatedDashboardSettingsTemplatesIndexRoute = authenticatedDashboardSettingsTemplatesIndexRouteImport.update({
            id: '/templates/',path: '/templates/',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardSettingsSyncIndexRoute = authenticatedDashboardSettingsSyncIndexRouteImport.update({
            id: '/sync/',path: '/sync/',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardSettingsProvidersIndexRoute = authenticatedDashboardSettingsProvidersIndexRouteImport.update({
            id: '/providers/',path: '/providers/',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardSettingsTemplatesNewRoute = authenticatedDashboardSettingsTemplatesNewRouteImport.update({
            id: '/templates/new',path: '/templates/new',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardSettingsProvidersAddRoute = authenticatedDashboardSettingsProvidersAddRouteImport.update({
            id: '/providers/add',path: '/providers/add',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardAdminModelsIndexRoute = authenticatedDashboardAdminModelsIndexRouteImport.update({
            id: '/models/',path: '/models/',getParentRoute: () => authenticatedDashboardAdminRouteRoute
          })
const authenticatedDashboardSettingsTemplatesTemplateIdIndexRoute = authenticatedDashboardSettingsTemplatesTemplateIdIndexRouteImport.update({
            id: '/templates/$templateId/',path: '/templates/$templateId/',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })
const authenticatedDashboardSettingsTemplatesTemplateIdEditRoute = authenticatedDashboardSettingsTemplatesTemplateIdEditRouteImport.update({
            id: '/templates/$templateId/edit',path: '/templates/$templateId/edit',getParentRoute: () => authenticatedDashboardSettingsRouteRoute
          })





const authPagesRouteRouteChildren = {
  authPagesForgotPasswordRoute: authPagesForgotPasswordRoute,authPagesLoginRoute: authPagesLoginRoute,authPagesResetPasswordRoute: authPagesResetPasswordRoute,authPagesSignupRoute: authPagesSignupRoute
}

const authPagesRouteRouteWithChildren = authPagesRouteRoute._addFileChildren(authPagesRouteRouteChildren)




const authenticatedDashboardAdminRouteRouteChildren = {
  authenticatedDashboardAdminIndexRoute: authenticatedDashboardAdminIndexRoute,authenticatedDashboardAdminModelsIndexRoute: authenticatedDashboardAdminModelsIndexRoute
}

const authenticatedDashboardAdminRouteRouteWithChildren = authenticatedDashboardAdminRouteRoute._addFileChildren(authenticatedDashboardAdminRouteRouteChildren)




const authenticatedDashboardSettingsRouteRouteChildren = {
  authenticatedDashboardSettingsIndexRoute: authenticatedDashboardSettingsIndexRoute,authenticatedDashboardSettingsProvidersAddRoute: authenticatedDashboardSettingsProvidersAddRoute,authenticatedDashboardSettingsTemplatesNewRoute: authenticatedDashboardSettingsTemplatesNewRoute,authenticatedDashboardSettingsProvidersIndexRoute: authenticatedDashboardSettingsProvidersIndexRoute,authenticatedDashboardSettingsSyncIndexRoute: authenticatedDashboardSettingsSyncIndexRoute,authenticatedDashboardSettingsTemplatesIndexRoute: authenticatedDashboardSettingsTemplatesIndexRoute,authenticatedDashboardSettingsTemplatesTemplateIdEditRoute: authenticatedDashboardSettingsTemplatesTemplateIdEditRoute,authenticatedDashboardSettingsTemplatesTemplateIdIndexRoute: authenticatedDashboardSettingsTemplatesTemplateIdIndexRoute
}

const authenticatedDashboardSettingsRouteRouteWithChildren = authenticatedDashboardSettingsRouteRoute._addFileChildren(authenticatedDashboardSettingsRouteRouteChildren)



const authenticatedDashboardRouteRouteChildren = {
  authenticatedDashboardAdminRouteRoute: authenticatedDashboardAdminRouteRouteWithChildren,authenticatedDashboardSettingsRouteRoute: authenticatedDashboardSettingsRouteRouteWithChildren,authenticatedDashboardIndexRoute: authenticatedDashboardIndexRoute,authenticatedDashboardChatChatIdRoute: authenticatedDashboardChatChatIdRoute,authenticatedDashboardChatNewRoute: authenticatedDashboardChatNewRoute
}

const authenticatedDashboardRouteRouteWithChildren = authenticatedDashboardRouteRoute._addFileChildren(authenticatedDashboardRouteRouteChildren)




const authenticatedOnboardingRouteRouteChildren = {
  authenticatedOnboardingCompleteRoute: authenticatedOnboardingCompleteRoute,authenticatedOnboardingProviderRoute: authenticatedOnboardingProviderRoute,authenticatedOnboardingTemplatesRoute: authenticatedOnboardingTemplatesRoute,authenticatedOnboardingTestConnectionRoute: authenticatedOnboardingTestConnectionRoute,authenticatedOnboardingIndexRoute: authenticatedOnboardingIndexRoute
}

const authenticatedOnboardingRouteRouteWithChildren = authenticatedOnboardingRouteRoute._addFileChildren(authenticatedOnboardingRouteRouteChildren)



const authenticatedRouteRouteChildren = {
  authenticatedDashboardRouteRoute: authenticatedDashboardRouteRouteWithChildren,authenticatedOnboardingRouteRoute: authenticatedOnboardingRouteRouteWithChildren
}

const authenticatedRouteRouteWithChildren = authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,authPagesRouteRoute: authPagesRouteRouteWithChildren,authenticatedRouteRoute: authenticatedRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)